import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { NgForm } from '@angular/forms';
import { ConfigService } from '../../service/config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ResetPasswordPage } from '../reset-password/reset-password.page';
import { LocaldataService } from '../../service/localdata/localdata.service';
import { AuthService } from '../../service/auth/auth.service';
import { Device } from '@capacitor/device';
import { DeviceService } from '../../service/device/device.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  public userProfile: any = JSON.parse('{"id":0}');
  public isLoggedin: boolean;
  //public isLoggedin$ = new BehaviorSubject<boolean>(this.isLoggedin);



  constructor(private domSanit: DomSanitizer, private config: ConfigService, private localData:LocaldataService,private auth:AuthService, private DeviceService: DeviceService, private http: HttpClient, private alertCtrl: AlertController, private router: Router, private modalCtrl: ModalController) {
    
  }

  ionViewWillEnter(){
    if(this.tokenValid) {
      //this.userProfile = lsProfile;
      //this.setLoggedIn(true);
      
      //this.DeviceService.initPushNotification();
      //localStorage.getItem('access_token') || '{}'
      let user = localStorage.getItem('profile') || '';
      let userprofile = JSON.parse(user);
      let usertype = userprofile?.usertype;
      if(usertype == 'weighin'){
        this.router.navigate(['/asb/weighins']);
      }else{
        this.router.navigate(['/asb/home']);
      }
      
      //this.router.navigate['/asb/home']

    }
  }

  ionViewDidEnter() {
    this.localData.checkVersionUpdate();
  }

  get tokenValid(): boolean {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return Date.now() < expiresAt;
  }



  async showAlert(header: string, subHeader: string){
    let alert = await this.alertCtrl.create({
      header: header,
      subHeader: subHeader,
      buttons: ['OK']
    });
    await alert.present();
  }


  private _getProfile(authResult) {
    let headerOptions = new HttpHeaders({ 'Authorization': authResult.id });

    const options = {
      headers: headerOptions
    };


    


    this.http.get(this.config.basePath + '/api/farmers/' + authResult.userId, options)
      .subscribe(
        (res: Response) => {
          if (res) {
            
              const expiresAt = JSON.stringify((authResult.ttl * 1000) + Date.now());
              

              localStorage.setItem('expires_at', expiresAt);

              localStorage.setItem('profile', JSON.stringify(res));

              localStorage.setItem('username', res['username']);

              this.userProfile = res;



              /*this.setLoggedIn(true);

              if(localStorage.getItem('device_token') && localStorage.getItem('device_token').length>0){
                this.registerDeviceId(localStorage.getItem('device_token'));
              }

              this.app.getActiveNav().push(DueslagPage).then(()=>{
                this.app.getActiveNav().setRoot(DueslagPage).then(()=>{
                });
              });
              */

              let userprofile = JSON.parse(JSON.stringify(res));
              let usertype = userprofile?.usertype;
              if(usertype == 'weighin'){
                this.router.navigate(['/asb/weighins']);
              }else{
                this.router.navigate(['/asb/home']);
              }

              //this.router.navigateByUrl('/asb/home');

              //const lsProfile = JSON.parse(localStorage.getItem('profile'));
              this.auth.userProfile = res;

              this.localData.remoteUpdateNotifications();
              this.localData.remoteUpdateFiles();
              this.localData.remoteUpdateFormsAvailable();
            
          }
        },
        (err) => {
          console.log(err.message);
        }
      );
  }


  login(form: NgForm) {

    this.DeviceService.initPushNotification();

    if (form.value.username) {
      form.value.username = form.value.username.toLowerCase();
    }


    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };



    this.http.post(this.config.basePath + '/api/farmers/login', form.value, options)
      .subscribe(
        (res: any) => {
          if (res) {
            //if (res.status === 200) {
              localStorage.setItem('access_token', res.id);
              
              this.DeviceService.registerDeviceId(localStorage.getItem('device_token'), res.userId);

              this._getProfile(res);

           // }
          }
        },
        (err) => {
          console.log('err', err);

          if (err.status == 401) {
            this.showAlert('Fejl ved log ind','CVR-nummeret eller adgangskoden er ikke korrekt. Kontrollér om du har tastet oplysningerne korrekt og tag ellers fat i avlerinfo.dk');
          }

          if (err.status == 0) {
            this.showAlert('Fejl ved log ind','Det ser ikke ud til at vi kan få forbindelse til avlerinfo.dks systemer. Prøv igen og tag ellers fat i avlerinfo.dk');
          }



        }
      );

  }

  async resetPassword(){
    let modal = await this.modalCtrl.create({
      component: ResetPasswordPage,
      componentProps: {
        modalCtrl: this.modalCtrl
      },
      backdropDismiss: true,
    });
    return await modal.present();
  }

  ngOnInit() {
  }

}
